interface PostHogResetClient {
  reset: () => void
}

interface StorageLike {
  getItem(key: string): string | null
  removeItem(key: string): void
  setItem(key: string, value: string): void
}

export const POSTHOG_AUTHENTICATED_DISTINCT_ID_STORAGE_KEY =
  "ringio.posthog.authenticated_distinct_id"

export function getAuthenticatedPostHogDistinctId({
  accountStatus,
  userId,
}: {
  accountStatus: string
  userId: number
}) {
  return accountStatus !== "LOGGED_OUT" && userId > 0 ? userId.toString() : null
}

export function readAuthenticatedPostHogDistinctId(
  storage?: StorageLike | null
) {
  try {
    return storage?.getItem(POSTHOG_AUTHENTICATED_DISTINCT_ID_STORAGE_KEY) ?? null
  } catch {
    return null
  }
}

export function persistAuthenticatedPostHogDistinctId(
  storage: StorageLike | null | undefined,
  distinctId: string | null
) {
  try {
    if (distinctId) {
      storage?.setItem(
        POSTHOG_AUTHENTICATED_DISTINCT_ID_STORAGE_KEY,
        distinctId
      )
      return
    }

    storage?.removeItem(POSTHOG_AUTHENTICATED_DISTINCT_ID_STORAGE_KEY)
  } catch {
    // Storage cleanup is best-effort and must never block account logout.
  }
}

export function resetPostHogIdentity(
  client: PostHogResetClient,
  storage?: StorageLike | null
) {
  try {
    client.reset()
  } catch {
    // Analytics cleanup must never block account logout.
  } finally {
    persistAuthenticatedPostHogDistinctId(storage, null)
  }
}
